module.exports = "app-lateralbar .navbar {\n  position: absolute;\n  right: 0;\n  top: 25%;\n  z-index: 1; }\n\napp-lateralbar .navbar-nav li {\n  margin-top: 100%;\n  font-size: 1.4em; }\n\napp-lateralbar .navbar-nav li a {\n  color: #fff;\n  opacity: 0.3; }\n\napp-lateralbar .navbar-nav li a:hover {\n  text-decoration: none; }\n\n@media (min-width: 575px) and (max-width: 1080px) {\n  app-lateralbar .navbar {\n    top: 10%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/lateralbar/lateralbar.component.scss
// module id = ./src/app/lateralbar/lateralbar.component.scss
// module chunks = main